<h2 mat-dialog-title>Login</h2>
<mat-dialog-content>
    <shared-login-form (login)="onSubmit($event)" [isPending]="isPending$ | async" [error]="error$ | async"> </shared-login-form>
</mat-dialog-content>
